import { useState, useEffect } from 'react'
import { theatreDashboardMockData } from '../utils/mockdata'

const useTheatreData = () => {
  const [theatres, setTheatres] = useState(theatreDashboardMockData)
  const [currentTime, setCurrentTime] = useState(new Date())

  // Simulate real-time updates
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date())
    }, 60000) // Update every minute

    return () => clearInterval(timer)
  }, [])

  // Calculate summary stats
  const activeTheatres = theatres.filter((theatre) => theatre.status === 'Active').length
  const idleTheatres = theatres.filter((theatre) => theatre.status === 'Idle').length
  const cleaningTheatres = theatres.filter((theatre) => theatre.status === 'Cleaning').length
  const totalProcedures = theatres.filter((theatre) => theatre.nextProcedure).length + activeTheatres

  return {
    theatres,
    setTheatres,
    currentTime,
    activeTheatres,
    idleTheatres,
    cleaningTheatres,
    totalProcedures
  }
}

export default useTheatreData
